import React from "react";
import {
  Button,
  Grid,
  Typography,
  Stack
} from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Modal from "../../Components/Modal";
import { users } from "../../Requests";
import useGlobalContext from "../../Hooks/useGlobalContext";
import { useSnackbar } from "notistack";

interface IRemoveUserProps {
  idUser: number;
  reloadResourceTable: () => void;
  close: () => void;
}

const RemoveUser: React.FC<IRemoveUserProps> = ({
  idUser,
  reloadResourceTable,
  close
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading, loading } = useGlobalContext();

  const handleCloseModal = () => close();

  const handleRemoveUser = async () => {
    if (!idUser) return;

    setLoading?.(true);

    const {
      data = "",
      status = 500,
      message = ""
    } = await users.delete(String(idUser));

    setLoading?.(false);

    if (data || message) {
      const variant = status === 200 || status === 204 ? "success" : "error";
      enqueueSnackbar(message || "Erro ao remover usuário", { variant });
    }

    reloadResourceTable();
    close();
  };

  return (
    <Modal
      title="Remover usuário"
      open={!loading}
      closeModal={handleCloseModal}
      maxWidth="sm"
    >
      <Grid container spacing={0.5}>
        <Grid item xs={12}>
          <Typography variant="body1">
            Tem certeza de que deseja remover este usuário?{" "}
            <Typography component="span" fontWeight="bold" color="error">
              Esta ação é irreversível!
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              aria-label="Cancelar remoção"
            >
              Cancelar
            </Button>

            <Button
              variant="contained"
              color="error"
              onClick={handleRemoveUser}
              startIcon={<DeleteForeverIcon />}
              aria-label="Confirmar remoção de usuário"
            >
              Remover usuário
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default RemoveUser;
